// ThemeDownloadBill.jsx
import React from 'react';
import './ThemeDownloadBill.css';

function ThemeDownloadBill(props) {
    return (
        <div className="loading-container">
            <div className="loader">
                <div className="ripple"></div>
                <div className="ripple"></div>
                <div className="image-icon"></div>
                <div className="loading-text">Đang tải ảnh...</div>
            </div>
        </div>
    );
}

export default ThemeDownloadBill;